import type { CSSProperties, ReactNode } from 'react'
import styles from './Badge.module.css'

interface BadgeProps {
  variant?: 'neutral' | 'accent' | 'success' | 'warning' | 'danger' | 'info'
  dot?: boolean
  children: ReactNode
  style?: CSSProperties
}

export function Badge({ variant = 'neutral', dot, children, style }: BadgeProps) {
  return (
    <span className={[styles.badge, styles[variant]].join(' ')} style={style}>
      {dot ? <span className={styles.dot} /> : null}
      {children}
    </span>
  )
}
